import {
    REQUEST_ENTERPRISE_CARD_PAY,
    SUCCESS_ENTERPRISE_CARD_PAY,
    FAILURE_ENTERPRISE_CARD_PAY,
    REQUEST_ENTERPRISE_CARD_DETAILS,
    SUCCESS_ENTERPRISE_CARD_DETAILS,
    FAILURE_ENTERPRISE_CARD_DETAILS,
    ENTERPRISE_CARD_PAYMENT_PARAM
} from './constants';
import { PATH } from '../../constants/path';
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';
import gtm from '../../utils/gtmUtils';

export function payWithEnterpriseCard(userInfo, partnerId, orderId) {
    return {
        [CALL_API]: {
            endpoint: `/enterprisecard/pay`,
            method: HTTP_METHOD_POST,
            body: { partnerId, ...userInfo, orderId },
            types: [
                REQUEST_ENTERPRISE_CARD_PAY,
                SUCCESS_ENTERPRISE_CARD_PAY,
                FAILURE_ENTERPRISE_CARD_PAY
            ],
            successCallback: response => {
                window.location.href = `${PATH.EBON_CONFIRMATION_PATH}?orderId=${orderId}&${ENTERPRISE_CARD_PAYMENT_PARAM}=true`;
            },
            finallyCallback: () => {
                gtm.event('add_payment_info', { payment_method: 'Enterprise Card' });
            }
        }
    };
}

export const fetchEnterpriseCardDetails = orderId => {
    return {
        [CALL_API]: {
            endpoint: `/payment-solution/enterprisecard/${orderId}/details`,
            types: [
                REQUEST_ENTERPRISE_CARD_DETAILS,
                SUCCESS_ENTERPRISE_CARD_DETAILS,
                FAILURE_ENTERPRISE_CARD_DETAILS
            ],
            method: HTTP_METHOD_GET
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/enterprisecard/actions.js